import React, { useEffect } from "react";
import km1 from "assets/images/km1.jpg";

const PHONE_DISPLAY = "010-3848-0591";
const TEL_URI = "tel:01038480591";
const LINKTREE = "https://www.kmheavy.kr";

export default function TelPage() {
  useEffect(() => {
    document.title = "계명종합중기 전화걸기";

    // 모바일 브라우저에서만 전화 앱 열기
    const isMobile = /iPhone|iPad|iPod|Android|Mobi/i.test(navigator.userAgent);
    let timerId;
    if (isMobile) {
      // 바로 전화 시도 후 3초 뒤 링크 이동
      window.location.href = TEL_URI;
      timerId = setTimeout(() => {
        window.location.href = LINKTREE;
      }, 3000);
    }
    return () => timerId && clearTimeout(timerId);
  }, []);

  const wrap = {
    fontFamily: "Arial, sans-serif",
    background: "#f9f9f9",
    minHeight: "100vh",
    margin: 0,
    display: "flex",
    flexDirection: "column",
  };

  const header = {
    background: "#191919",
    color: "#fff",
    padding: "24px 0",
    textAlign: "center",
  };

  const section = {
    textAlign: "center",
    padding: "16px 20px",
  };

  const phone = { fontSize: "1.6rem", color: "#007bff", margin: 0 };

  const imgWrap = { display: "flex", justifyContent: "center", padding: 16 };

  const img = {
    maxWidth: "1100px",
    width: "100%",
    height: "auto",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgba(0,0,0,.2)",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };

  const footer = {
    marginTop: "auto",
    width: "100%",
    padding: "16px 0",
    background: "#EAEAEA",
    color: "#888",
    fontSize: "0.95rem",
    textAlign: "center",
  };

  return (
    <div style={wrap}>
      <header style={header}>
        <h1 style={{ margin: 0, fontSize: "2rem", fontWeight: 700 }}>계명종합중기</h1>
      </header>

      <main style={section}>
        <h3 style={{ marginTop: 0 }}>데스크톱 사용자는 아래 번호를 이용하세요</h3>
        <p style={phone}>📞 {PHONE_DISPLAY}</p>
        <p style={{ color: "#666", marginTop: 16 }}>
          자동으로 전화 연결이 되지 않을 경우 아래 버튼을 눌러 주세요.
        </p>

        <div style={imgWrap}>
          <a href={LINKTREE} target="_blank" rel="noopener noreferrer">
            <img src={km1} alt="계명종합중기 로고" style={img} />
          </a>
        </div>

        {/* 수동 동작용 백업 버튼들 (모바일 자동 연결이 동작하지 않을 때) */}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 12 }}>
          <a
            href={TEL_URI}
            style={{
              padding: "10px 14px",
              border: "1px solid #222",
              borderRadius: "8px",
              textDecoration: "none",
            }}
          >
            📞 전화 걸기
          </a>
          <a
            href={LINKTREE}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "10px 14px",
              border: "1px solid #222",
              borderRadius: "8px",
              textDecoration: "none",
            }}
          >
            🗺️ 홈페이지 열기
          </a>
        </div>
      </main>

      <footer style={footer}>
        <p style={{ margin: 0 }}>© 2024 계명종합중기. All rights reserved.</p>
      </footer>
    </div>
  );
}
